import { useState, useEffect } from 'react'
import './UpdateBanner.css'

const UpdateBanner = () => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const handler = () => setShow(true)
    window.addEventListener('pwa-updating', handler)
    return () => window.removeEventListener('pwa-updating', handler)
  }, [])

  if (!show) return null

  return (
    <div className="update-banner">
      <span className="update-banner-spinner" />
      Actualizando GrowPro Admin...
    </div>
  )
}

export default UpdateBanner
